export default "__VITE_ASSET__HzR$OFeT__"